import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FleetService } from '../../../core/services/fleet.service';
import { SETTINGS } from '../../../core/config/common.settings';
import * as _ from 'lodash';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ReportsService } from '../../../core/services/reports.service';
import { PageSize } from '../../../core/dto/page.size';
import { Pagination } from '../../../core/dto/pagination';
import { InventoryService } from '../../../core/services/inventory.service';

@Component({
  selector: 'app-single-view-fleet',
  templateUrl: './single-view-fleet.component.html',
  styleUrls: ['./single-view-fleet.component.scss'],
})
export class SingleViewFleetComponent implements OnInit, AfterViewInit {
  activeTabIndex = 0;
  effect = 'scrollx';
  selector = true;
  fleetId: any;
  fleetData: any;
  vehicleCat: any;
  breadcrumbs: any[] = [];
  addOrEditAccident = false;
  availabilityStatus = SETTINGS.AVAILABILITY_STATUS;
  date = new Date();
  isVisibleFleetNoteModal = false;
  description = '';
  loading = false;
  isShowReport = false;
  pdf: any;
  pdfLoader = false;
  selectedImage = '';
  isVisible = false;
  imgUploadPlaceholder = SETTINGS.UPLOAD_PLACEHOLDER;
  pageSize = new PageSize();
  sortField: any;
  sortOrder: any = -1;
  inventoryData: any[] = []; // Initialize with dummy data

  isOpen = '';

  constructor(
    private route: ActivatedRoute,
    private fleetService: FleetService,
    private router: Router,
    private message: NzMessageService,
    private reportService: ReportsService,
    private inventoryService: InventoryService,
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.fleetId = this.route.snapshot.paramMap.get('id');
    this.getVehicleDetails();
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      filters: {
        searchValue: '',
        fleetId: this.fleetId,
      },
    });
    this.inventoryService.getInventoryPaged(payload).then((res: any) => {
      this.inventoryData = res.data;
    });
  }

  ngAfterViewInit() {
    //   this.router.events.subscribe(event => {
    //     if (event instanceof NavigationEnd) {
    //       // Scroll to the top or any desired position
    //       window.scrollTo(0, 0);
    //       window.document.body.scrollTop = 0;
    //       window.document.documentElement.scrollTop = 0;
    //     }
    //   });
    //   // window.scrollTo(0, 0);
    window.document.body.scrollTop = 0;
    //   // window.document.documentElement.scrollTop = 0;
  }

  getVehicleDetails(): void {
    this.loading = true;
    this.fleetService.getOneFleetById(this.fleetId).then((res) => {
      this.fleetData = res as any;
      this.setBreadcrumbs(res);
      this.fleetService
        .getVehicleCatCode(this.fleetData.generalInformation.vehicleCategory)
        .then((res) => {
          this.vehicleCat = res as any;
          this.loading = false;
        });
      this.tabSelect();
    });
  }

  tabSelect() {
    this.route.params.subscribe((params) => {
      const parameter = params['pageName'];
      if (parameter === 'fleetService') {
        this.updateBreadcrumbs('Services');
        this.activeTabIndex = 2;
        this.isOpen = 'services';
      } else if (parameter === 'fleetInventory') {
        this.updateBreadcrumbs('Inventories');
        this.activeTabIndex = 1;
        this.isOpen = 'inventories';
      } else if (parameter === 'fleetAccident') {
        this.updateBreadcrumbs('Accidents');
        this.activeTabIndex = 4;
        this.isOpen = 'accidents';
      } else if (parameter === 'fleetRepairs') {
        this.updateBreadcrumbs('Repairs');
        this.activeTabIndex = 3;
        this.isOpen = 'repairs';
      } else if (parameter === 'generalInformation') {
        // this.updateBreadcrumbs('General-Info');
        this.activeTabIndex = 0;
        this.isOpen = '';
      }
    });
  }

  setBreadcrumbs(data: any): void {
    this.breadcrumbs = [
      {
        title: `Fleets `,
        route: '/admin/fleets',
        icon: 'car',
      },
      {
        title: ` ${data?.vehicleDetails?.registrationNumber} `,
        // route: `/admin/fleets/${this.fleetId}`,
      },
    ];
  }

  updateBreadcrumbs(tab: string): void {
    switch (tab) {
      case 'General-Info':
        this.isOpen = '';
        this.breadcrumbs = [
          {
            title: ` Fleets `,
            route: '/admin/fleets',
            icon: 'car',
          },
          {
            title: `${this.fleetData?.vehicleDetails?.registrationNumber} `,
            route: `/admin/fleets/${this.fleetId}`,
          },
        ];
        break;
      case 'Accidents':
        this.isOpen = 'accidents';
        this.breadcrumbs = [
          {
            title: ` Fleets `,
            route: '/admin/fleets',
            icon: 'car',
          },
          {
            title: `${this.fleetData?.vehicleDetails?.registrationNumber} `,
            route: `/admin/fleets/${this.fleetId}`,
          },
          {
            title: ` Accident Records`,
          },
        ];
        break;

      case 'Repairs':
        this.isOpen = 'repairs';
        this.breadcrumbs = [
          {
            title: ` Fleets `,
            route: '/admin/fleets',
            icon: 'car',
          },
          {
            title: `${this.fleetData?.vehicleDetails?.registrationNumber} `,
            route: `/admin/fleets/${this.fleetId}`,
          },
          {
            title: ` Repair Records`,
          },
        ];
        break;

      case 'Inventories':
        this.isOpen = 'inventories';
        this.breadcrumbs = [
          {
            title: ` Fleets `,
            route: '/admin/fleets',
            icon: 'car',
          },
          {
            title: `${this.fleetData?.vehicleDetails?.registrationNumber} `,
            route: `/admin/fleets/${this.fleetId}`,
          },
          {
            title: ` Inventory Records`,
          },
        ];
        break;

      case 'Services':
        this.isOpen = 'services';
        this.breadcrumbs = [
          {
            title: ` Fleets `,
            route: '/admin/fleets',
            icon: 'car',
          },
          {
            title: `${this.fleetData?.vehicleDetails?.registrationNumber} `,
            route: `/admin/fleets/${this.fleetId}`,
          },
          {
            title: ` Service Records`,
          },
        ];
        break;

      case 'Notes':
        this.isOpen = 'notes';
        this.breadcrumbs = [
          {
            title: ` Fleets `,
            route: '/admin/fleets',
            icon: 'car',
          },
          {
            title: `${this.fleetData?.vehicleDetails?.registrationNumber} `,
          },
          {
            title: ` Notes and Attachments`,
          },
        ];
        break;
    }
  }

  showAddEdit(): void {
    this.addOrEditAccident = !this.addOrEditAccident;
  }

  goto(): void {
    this.router.navigate([
      `/admin/fleets/add-edit/${this.fleetId}`,
      { backLoc: 'single' },
    ]);
  }

  async changeStatus(): Promise<void> {
    this.loading = true;
    await this.fleetService.updateFleet({
      _id: this.fleetId,
      active: !this.fleetData.active,
      updateType: 'status_change',
    });
    if (this.fleetData.active) {
      this.message.create('success', `Vehicle has been deactivated!`);
    } else {
      this.message.create('success', `Vehicle has been activated!`);
    }

    await this.fleetService.getFleetRemarksByFleet(this.fleetId);
    this.getVehicleDetails();
  }

  // Fleet modal stuff
  showAddFleetNoteModal(): void {
    this.isVisibleFleetNoteModal = true;
  }

  handleOkAddFleetNote(): void {
    this.loading = true;
    this.fleetService
      .createFleetRemark({
        description: this.description,
        action: this.fleetData?.active ? 'Deactivated' : 'Activated',
        fleet: this.fleetId,
      })
      .then(() => {
        this.changeStatus();
        this.isVisibleFleetNoteModal = false;
        this.description = '';
      });
  }

  handleCancelAddFleetNote(): void {
    this.isVisibleFleetNoteModal = false;
    this.description = '';
  }

  hasPermission(perm: string): boolean {
    return _.includes(localStorage.getItem(SETTINGS.USER_PERMISSIONS), perm);
  }

  cancel(): void {}

  showReportGenerate(): void {
    this.isShowReport = true;
  }

  handleCancel(): void {
    this.isShowReport = false;
  }

  handleCanceImgModall(): void {
    this.selectedImage = '';
    this.isVisible = false;
  }

  showModalImg(image: string): void {
    this.selectedImage = image;
    this.isVisible = true;
  }

  generatePdf(): void {
    this.selector = true;
    this.pdfLoader = false;
    this.reportService.generateRentalReport(this.fleetData).then((res) => {
      this.pdf = res;
      this.pdfLoader = true;
    });
  }

  generateInventoryPdf(): void {
    this.selector = false;
    this.pdfLoader = false;
    this.reportService.generateInventoryReport(this.fleetId).then((res) => {
      this.pdf = res;
      this.pdfLoader = true;
    });
  }

  emailPdf(): void {
    this.reportService.emailPdf();
    // const email = 'recipient@gmail.com';
    // const subject = 'Your email subject';
    // const body = 'Your email body content';
    //
    // // Create the mailto link
    // // Open the default email client (Gmail, if available)
    // window.location.href = `mailto:${email}?subject=${encodeURIComponent(
    //   subject,
    // )}&body=${encodeURIComponent(body)}`;
  }

  printReport(): void {
    this.reportService.printReport(this.pdf).then(() => {});
  }

  viewPdf(): void {
    this.reportService.viewReport(this.pdf);
  }

  downloadPdf(): void {
    this.reportService.downloadReport(this.pdf);
  }

  havePermissionWithOtherValues(
    permission: string,
    vehicleType: string,
    checkingType: string,
  ): boolean {
    // if (have) {

    return (
      _.includes(localStorage.getItem(SETTINGS.USER_PERMISSIONS), permission) &&
      vehicleType === checkingType
    );
    // } else {
    //   return (
    //     !_.includes(
    //       localStorage.getItem(SETTINGS.USER_PERMISSIONS),
    //       permission,
    //     ) && bookingStatus === checkingStatus
    //   );
    // }
  }
  agreementRentingPeriodCheck(type: string): string {
    const options = SETTINGS.AGREEMENT_RENTING_PERIOD;
    const data = options.find((pe: any) => pe.value === type);
    return data?.label ? data?.label : '';
  }
  agreementEntitledKmsCheck(type: string): string {
    const options = SETTINGS.AGREEMENT_ENTITLED_KMS;
    const data = options.find((pe: any) => pe.value === type);
    return data?.label ? data?.label : '-';
  }
  labelValOnServiceType(name: string) {
    let value = '-';
    switch (name) {
      case 'SR': {
        value = 'SR';
        break;
      }
      case 'OWNER': {
        value = 'Vehicle Owner';
        break;
      }
      default: {
        break;
      }
    }
    return value;
  }
}
